<template>
<div>
	<div class="form-group input-group-sm" v-if="jsa.jsa_steps">
		<label>Standard Controls:</label>
		<multiselect :name="name"
		v-model="jsa.jsa_steps[step_id].hazards[hazard_id].controls"
		:multiple="true"
		:close-on-select="false"
		:clear-on-select="false"
		:options="controls"
		group-values="children"
		group-label="hazard_name"
		track-by="text"
		label="text"
		class="control-input form-control"></multiselect>
	</div>
</div>
</template>


<script>
    export default {
    	props: ['name', 'step_id', 'hazard_id'],

        data: function() {
            return {
                loading: true,
                jsa: {},
                errors: {},
                controls: [],
            }
        },

        watch: {
        	jsa: function() {
        		if(this.jsa.jsa_steps[this.step_id].hazards[this.hazard_id].controls) {
        			this.$store.commit('putJsa', this.jsa);
        		}
        	},
        },

        mounted() {
    		this.jsa = this.$store.state.JsaStoreModule.jsa;
    		this.controls   = this.$store.state.JsaStoreModule.controls;
        }
  }
</script>



